import React from "react";
import {
    Box,
    Chip,
    MenuItem,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import { BORDA_SUAVE, NAVY, SUPERFICIE, rotuloStatus } from "./utils";

const campoSx = {
    minWidth: "8.5rem",
    "& .MuiOutlinedInput-root": {
        backgroundColor: "white",
        borderRadius: "10px",
        "& fieldset": { borderColor: "#DCE3EF" },
        "&:hover fieldset": { borderColor: "#B7C3D9" },
        "&.Mui-focused fieldset": { borderColor: NAVY }
    }
};

const chipSx = (ativo) => (ativo
    ? {
        backgroundColor: NAVY,
        color: "white",
        fontWeight: 600,
        "&:hover": { backgroundColor: NAVY }
    }
    : {
        backgroundColor: "white",
        color: "#5A6B8C",
        border: "1px solid #DCE3EF",
        "&:hover": { backgroundColor: "rgba(19, 35, 80, 0.06)" }
    });

const OPCOES_STATUS = [
    { valor: "", rotulo: "Todos" },
    { valor: "G", rotulo: rotuloStatus("G") },
    { valor: "C", rotulo: rotuloStatus("C") },
    { valor: "I", rotulo: rotuloStatus("I") },
    { valor: "X", rotulo: rotuloStatus("X") },
    { valor: "nao-gerado", rotulo: "Não gerado" }
];

const FiltrosIntegracao = ({ filtros, onChange, diasFaturamento = [], diasVencimento = [], aba }) => {
    function alterar(campo, valor) {
        onChange({ ...filtros, [campo]: valor });
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                p: 2,
                mb: 2,
                borderRadius: "16px",
                backgroundColor: SUPERFICIE,
                border: `1px solid ${BORDA_SUAVE}`
            }}
        >
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "flex-end" }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                    <Typography variant="caption" sx={{ fontWeight: 600, color: NAVY }}>
                        Dia Faturamento
                    </Typography>
                    <TextField
                        select
                        size="small"
                        value={filtros.diaFaturamento}
                        onChange={(e) => alterar("diaFaturamento", e.target.value)}
                        sx={campoSx}
                        inputProps={{ "aria-label": "Dia Faturamento" }}
                    >
                        <MenuItem value="">Todos</MenuItem>
                        {diasFaturamento.map((dia) => (
                            <MenuItem key={dia} value={dia}>{String(dia).padStart(2, "0")}</MenuItem>
                        ))}
                    </TextField>
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                    <Typography variant="caption" sx={{ fontWeight: 600, color: NAVY }}>
                        Dia Vencimento
                    </Typography>
                    <TextField
                        select
                        size="small"
                        value={filtros.diaVencimento}
                        onChange={(e) => alterar("diaVencimento", e.target.value)}
                        sx={campoSx}
                        inputProps={{ "aria-label": "Dia Vencimento" }}
                    >
                        <MenuItem value="">Todos</MenuItem>
                        {diasVencimento.map((dia) => (
                            <MenuItem key={dia} value={dia}>{String(dia).padStart(2, "0")}</MenuItem>
                        ))}
                    </TextField>
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                    <Typography variant="caption" sx={{ fontWeight: 600, color: NAVY }}>
                        Número de Série
                    </Typography>
                    <TextField
                        size="small"
                        placeholder="Ex: 000000"
                        value={filtros.numeroSerie}
                        onChange={(e) => alterar("numeroSerie", e.target.value)}
                        sx={campoSx}
                    />
                </Box>

                <Box sx={{ flex: 1, minWidth: "14rem", display: "flex", flexDirection: "column", gap: 0.5 }}>
                    <Typography variant="caption" sx={{ fontWeight: 600, color: NAVY }}>
                        {aba === "bma" ? "Cliente" : "Revenda"}
                    </Typography>
                    <TextField
                        size="small"
                        placeholder={aba === "bma" ? "Buscar cliente..." : "Buscar revenda..."}
                        value={filtros.busca}
                        onChange={(e) => alterar("busca", e.target.value)}
                        sx={{ ...campoSx, minWidth: 0 }}
                        fullWidth
                    />
                </Box>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
                <Typography variant="caption" sx={{ fontWeight: 600, color: NAVY }}>
                    Status
                </Typography>
                <Stack direction="row" spacing={0} useFlexGap flexWrap="wrap" sx={{ gap: 0.75 }}>
                    {OPCOES_STATUS.map((opcao) => (
                        <Chip
                            key={String(opcao.valor)}
                            label={opcao.rotulo}
                            size="small"
                            clickable
                            onClick={() => alterar("status", opcao.valor)}
                            sx={chipSx(filtros.status === opcao.valor)}
                        />
                    ))}
                </Stack>
            </Box>
        </Box>
    );
};

export default React.memo(FiltrosIntegracao);
